//TODO update schema in https://varomoney.atlassian.net/browse/JT-120290
import { BestActionResultV2Fragment } from 'services/graphql/fragments/Fragments';
import { gql } from 'urql';

const GetBestAction = gql`
  query GetBestAction($input: BestActionInputV2!) {
    bestActionV2(input: $input) {
      ...BestActionResultV2Fragment
    }
  }
  ${BestActionResultV2Fragment}
`;

export default GetBestAction;
